module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-regular.fe15f45f.eot";